import useSWR from 'swr';
import { fetcher } from './base';

export const useFeatureFlags = () => useSWR('/feature-flags', fetcher);
